<template>
    <v-navigation-drawer
        v-model="drawer"
        fixed
        @input="closeDrawer"
        temporary >
        <v-list
            nav
            dense >
            <v-list-item-group
                v-model="group"
                active-class="deep-purple--text text--accent-4">
                <v-list-item>
                    <v-list-item-title>Quem somos?</v-list-item-title>
                </v-list-item>

                <v-list-item>
                    <v-list-item-title>Seguros</v-list-item-title>
                </v-list-item>

                <v-list-item>
                    <v-list-item-title>Parceiros</v-list-item-title>
                </v-list-item>

                <v-list-item>
                    <v-list-item-title>Contato</v-list-item-title>
                </v-list-item>
                <v-list-item>
                    <v-list-item-title>Assessorados</v-list-item-title>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
    props: {
        drawer: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            group: ""
        }
    },
    methods: {
        closeDrawer(val) {
            this.$emit('changeDrawer', val)
        }
    }
}
</script>